import React from "react"
import { connect } from "react-redux"
import { createStyles } from "@mantine/core"

import { segueToSearch } from "app/static/frontend/search-new/action-creators"
import { StatCell } from "app/static/frontend/sheets/components/cells/MantineCells/StatCell"
import Tooltip from "app/static/frontend/components/Tooltip"

import { searchStatCellConnection } from "app/static/frontend/sheets/selectors/column-selectors"

const useStyles = createStyles(() => ({
    searchSegue: {
        "&:hover": {
            textDecoration: "underline",
        },
    },
}))

const SearchStatCellComponent = ({
    allowSegueToSearch, // whether we should allow users to segue to search from the Sheet
    children,
    searchDataType,
    segueToSearch,
    segueToSearchArgs,
    ...props
}) => {
    const { classes, cx } = useStyles()

    if (allowSegueToSearch && Boolean(children)) {
        return (
            <Tooltip label={`View all of these ${searchDataType} in search`}>
                <StatCell
                    {...props}
                    data-interactive
                    className={cx(classes.searchSegue, props.className)}
                    onClick={() => segueToSearch(segueToSearchArgs)}
                >
                    {children}
                </StatCell>
            </Tooltip>
        )
    }

    return <StatCell {...props}>{children}</StatCell>
}

export const SearchStatCell = connect(searchStatCellConnection, { segueToSearch })(SearchStatCellComponent)
